// extracted by mini-css-extract-plugin
module.exports = {"features":"cd01fbf7b5--features--iH2Hk","list":"cd01fbf7b5--list--wN4VC"};